// extracted by mini-css-extract-plugin
module.exports = {"bbb":"scaffold_bbb__PgvGm","bro":"scaffold_bro__1UOrt","brah":"scaffold_brah__14tXC","paneContainer":"scaffold_paneContainer__31Oxq"};